module.exports = __webpack_public_path__ + "static/media/create_new_invoice.6d638d7a.png";